export default __webpack_public_path__ + "static/media/english-bg.8a0ee862.webp";